<template functional>
  <container-priority
    :item="{ id: props.item.id, priority: props.item.priority }"
  />
</template>

<script>
export default {
  name: "drayage-priority",
  functional: true,
  props: {
    item: Object,
    options: Object,
  },
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
